import React, { useCallback, useMemo } from "react";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { api } from "@/redux/api";
import { buildFacilityPath, getFacilityContext } from "@/utils/route-context";
import ContractList from "@/containers/contract/ContractList";
import { useAuthEditable } from "@/hooks/use-auth";

export default function FacilityContractPage() {
  const selectedFacilityId = useSelector((state) => state.Facility?.selected?.Id);
  const selectedFacility = useSelector((state) => state.Facility?.selected);
  const facilityContext = useSelector((state) => getFacilityContext(state));
  const { companyId: routeCompanyId, facilityId: routeFacilityId } = useParams();
  const canCreate = useAuthEditable("contract");
  const companyId = routeCompanyId || facilityContext.companyId;
  const facilityIds = useMemo(() => {
    const currentFacilityId = Number(routeFacilityId) || selectedFacilityId;
    return currentFacilityId ? [currentFacilityId] : [];
  }, [routeFacilityId, selectedFacilityId]);

  const loadRequests = useCallback(
    (selectedFacilityIds, params) => api.getContracts(selectedFacilityIds, params),
    []
  );
  const getDetailPath = useCallback(
    (record) => {
      return buildFacilityPath(`contract-request-detail/${record.id}`, facilityContext) || "/switch-view";
    },
    [facilityContext]
  );

  return (
    <ContractList
      facilityIds={facilityIds}
      facilities={facilityIds.map((id) => ({
        id,
        name: selectedFacility?.name || selectedFacility?.Name || `Facility #${id}`,
      }))}
      companyIds={companyId ? [companyId] : []}
      companies={companyId ? [{
        id: companyId,
        name: selectedFacility?.company_name || selectedFacility?.company?.name || `Company #${companyId}`,
      }] : []}
      loadRequests={loadRequests}
      getDetailPath={getDetailPath}
      showRequesterColumn
      canCreate={canCreate}
      createPath={buildFacilityPath("create-contract-request", facilityContext) || "/switch-view"}
    />
  );
}
